import { alphabetSorterFactory, columnDefinitionFactory } from './helpers';
export const mainTableColumns = [
    columnDefinitionFactory('uri', 'Uri'),
    columnDefinitionFactory('email', 'Email'),
    columnDefinitionFactory('firstName', 'First Name'),
    columnDefinitionFactory('lastName', 'Last Name'),
    columnDefinitionFactory('initials', 'Initials'),
    columnDefinitionFactory('avatarImgUrl', 'Avatar Image URL'),
    columnDefinitionFactory('fill', 'fill'),
    columnDefinitionFactory('stroke', 'Stroke'),
];
export const userBaseTableColumns = [
    {
        title: 'Property',
        dataIndex: 'key',
        key: 'key',
        sorter: alphabetSorterFactory('key'),
    },
    {
        title: 'Value',
        dataIndex: 'value',
        key: 'value',
    },
];
export const userTeamTableColumns = [
    {
        title: 'Property',
        dataIndex: 'key',
        key: 'key',
        sorter: alphabetSorterFactory('key'),
    },
    {
        title: 'Value',
        dataIndex: 'value',
        key: 'value',
    },
];
export const userMetaDataTableColumns = [
    {
        title: 'Property',
        dataIndex: 'key',
        key: 'key',
        sorter: alphabetSorterFactory('key'),
    },
    {
        title: 'Value',
        dataIndex: 'value',
        key: 'value',
    },
];
//# sourceMappingURL=columns.js.map